<template>
  <b-modal v-model="show" title="Макроиқтисодий кўрсаткичлар" size="xl" :no-close-on-esc="true"
           :no-close-on-backdrop="true">
    <div class="container-fluid">
      <div class="wrapper">

        <!-- 🔥 KO‘RSATKICH QO‘SHISH -->
        <div class="controls">
          <input type="text" v-model="newIndicator" placeholder="Кўрсаткич номи"/>
          <button class="btn btn-primary" @click="addIndicator" v-if="hasPermission('SETTINGS_MACROECONOMIC_INDICATORS_ADD')">+ Кўрсаткич қўшиш</button>
        </div>

        <div class="table-wrapper">
          <table class="table table-bordered">
            <thead>
            <tr>
              <th>Кўрсаткичлар</th>
              <th>Ўлчов бирлиги</th>
              <th v-for="year in years" :key="year">{{ year }}</th>
              <th>⚙️</th>
            </tr>
            </thead>
            <tbody>
            <template
                v-if="dictionaryData && dictionaryData.data && dictionaryData.data.indicators && dictionaryData.data.indicators.length > 0">
              <template v-for="(indicator, i) in dictionaryData.data.indicators">
                <tr v-for="(row, rI) in indicator.rows" :key="`indicator-${i}-row-${rI}`">
                  <td :rowspan="indicator.rows.length" class="title" v-if="rI === 0">
                    <div class="d-flex align-items-center">
                      <input type="text" v-model="indicator.title" placeholder="Кўрсаткич номи"/>
                      <button class="btn btn-primary text-nowrap" @click="addType(i)">+ Ўлчов бирлиги</button>
                    </div>
                  </td>

                  <td>
                    <input type="text" v-model="row.label" style="min-width: 30px;" placeholder="Ўлчов бирлиги"/>
                  </td>
                  <td v-for="(val, index) in row.values || Array(years.length).fill('')"
                      :key="`indicator-${i}-row-${rI}-${index}`">
                    <input type="text" v-model="row.values[index]" placeholder="101,6"/>
                  </td>
                  <td>
                    <button class="btn btn-danger" @click="removeType(i, rI)">❌</button>
                  </td>
                </tr>
              </template>
            </template>

            </tbody>
          </table>
        </div>

      </div>
    </div>

    <div slot="modal-footer" class="w-100 pt-3" style="border-top: 1px solid #CCCCCC">
      <button class="all-btn add-btn float-right" v-if="hasPermission('SETTINGS_MACROECONOMIC_INDICATORS_ADD')" @click="save" :disabled="processing || dictionaryData.id">
        Сақлаш
      </button>
      <button class="all-btn delete-btn float-right mr-2" @click="close">
        Бекор қилиш
      </button>
    </div>
  </b-modal>
</template>

<script>
import bModal from 'bootstrap-vue/es/components/modal/modal'
import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
import DropZone from '@/views/dropZone/DropZone'
import DatePicker from 'vuejs-datepicker';
import {BCollapse} from 'bootstrap-vue/es/components/collapse/collapse';
import {VBToggle} from 'bootstrap-vue/es/directives/toggle/toggle'

export default {
  name: "MacroeconomicIndicatorsModal",
  components: {
    'b-modal': bModal,
    DropZone,
    'date-picker': DatePicker,
    BCollapse
  },
  directives: {
    'b-modal': bModalDirective,
    'b-toggle': VBToggle
  },

  data() {
    const currentYear = new Date().getFullYear();
    return {
      show: false,
      processing: false,
      years: Array.from({length: 6}, (_, i) => (currentYear - 1) - 5 + i),
      dictionaryData: {}, // har bir element = { title: "Ko‘rsatkich", rows: [{label:"Tur", values: ["","","","",""]}] }
      newIndicator: "" // yangi ko‘rsatkich nomi input
    };
  },
// // Validatsiya
//   validations() {
//     let errors = [];
//     if (!this.dictionaryData.length) {
//       errors.push("Hech qanday ko‘rsatkich qo‘shilmagan.");
//     }
//     this.dictionaryData.forEach((indicator, i) => {
//       if (!indicator.title || !indicator.title.trim()) {
//         errors.push(`Ko‘rsatkich ${i + 1} nomi bo‘sh bo‘lishi mumkin emas.`);
//       }
//       indicator.rows.forEach((row, rIndex) => {
//         if (!row.label || !row.label.trim()) {
//           errors.push(`Ko‘rsatkich "${indicator.title}", Tur ${rIndex + 1} nomi bo‘sh bo‘lishi mumkin emas.`);
//         }
//         row.values.forEach((val, vIndex) => {
//           if (val !== "" && isNaN(Number(val))) {
//             errors.push(`Ko‘rsatkich "${indicator.title}", Tur "${row.label}", Yil ${this.years[vIndex]} qiymati raqam bo‘lishi kerak.`);
//           }
//         });
//       });
//     });
//     if (errors.length) {
//       alert(errors.join("\n"));
//       return false;
//     }
//     return true;
//   },
  methods: {
    initData() {
      return {
        id: null,
        dictionaryType: 'MACROECONOMIC_INDICATORS',
        data: {
          years: this.years,
          indicators: [
            {
              title: this.newIndicator ? this.newIndicator.trim() : '',
              rows: [
                {
                  label: " ",
                  values: Array(this.years.length).fill("")
                }
              ]
            }
          ]
        }
      }
    },

    // ➕ Янги кўрсаткич (1 ta tur va 5 yil bo‘sh qiymat bilan)
    addIndicator() {
      if (!this.newIndicator.trim()) return;

      this.dictionaryData.data.indicators.push({
        title: this.newIndicator ? this.newIndicator.trim() : '',
        rows: [
          {
            label: " ",
            values: Array(this.years.length).fill("")
          }
        ]
      });
      this.newIndicator = "";
    },

    // ➕ Ўлчов бирлиги
    addType(i) {
      this.dictionaryData.data.indicators[i].rows.push({
        label: " ",
        values: Array(this.years.length).fill("")
      });
    },

    // ❌ Tur o‘chirish
    removeType(i, rIndex) {
      const indicators = this.dictionaryData.data.indicators;

      indicators[i].rows.splice(rIndex, 1);

      // agar rows bo‘sh bo‘lsa indikatorni ham o‘chiramiz
      if (indicators[i].rows.length === 0) {
        indicators.splice(i, 1);
      }
    },

    loadIndicators(data) {
      if (!data || !Array.isArray(data)) return [];

      // Har bir ko‘rsatkichni formatlaymiz
      return data.map(indicator => {
        return {
          title: indicator.title || "Янги кўрсаткич",
          rows: Array.isArray(indicator.rows) && indicator.rows.length > 0
              ? indicator.rows.map(row => ({
                label: row.label || "Ўлчов бирлиги",
                values: Array.isArray(row.values) && row.values.length === this.years.length
                    ? row.values
                    : Array(this.years.length).fill("")
              }))
              : [{label: "Ўлчов бирлиги", values: Array(this.years.length).fill("")}]
        }
      });
    },

    init() {
      // const vm = this;
      // vm.dictionaryData = [];
      // this.$http.post('/province/list', vm.filterProvince)
      //     .then(res => {
      //       // vm.provinces = this.getAsMaps(res.data);
      //     }, err => {
      //       console.log(err);
      //     });
    },

    // getAsMaps(result) {
    //   if (result && result.data && result.data.length > 0) {
    //     return result.data.map(d => ({id: d.id, name: d.name}))
    //   }
    //   return [];
    // },

    save() {
      const vm = this;
      vm.processing = true;

      console.log("this.dictionaryData    =   ", this.dictionaryData);
      this.$http.post('dictionary/save/macroeconomic-indicators', this.dictionaryData)
          .then(res => {
            const response = res.data;
            if (response.status === 'SUCCESS') {
              vm.show = false;
              this.dictionaryData = this.initData()
              this.$emit('change')
            }
            vm.processing = false;
          }, err => {
            vm.processing = false;
            console.log(err);
          });
    },
    close() {
      this.show = false;
    }
  },
  created() {
    this.$eventBus.$on('showMacroeconomicIndicators', (data) => {
      console.log("showMacroeconomicIndicators------", data);
      console.log("showMacroeconomicIndicators------");
      if (data) {
        console.log("showMacroeconomicIndicators-==============");
        this.dictionaryData = data; // mavjud ma’lumotlarni yuklaymiz
        console.log("this.dictionaryData-==============", this.dictionaryData);
      } else {
        this.dictionaryData = this.initData(); // har bir element = { title: "Ko‘rsatkich", rows: [{label:"Tur", values: ["","","","",""]}] }
      }
      this.show = true;
    })
  }


}
</script>

<style scoped>

</style>